
(function () {
  'use strict';
  class Controller {
    constructor($window, $firedux) {
      this._ = $window._;
      this.firebase = $window.firebase;
      this.$firedux = $firedux;
      this.$apply = () => $firedux.$apply();
    }
    $getTiers(tiers) {
      return this._(tiers).chain().pairs().filter('1').map('0').value().join(', ');
    }
    $approve(itemId) {
      return this.$firedux.ref('tierUpdates').child(itemId).set(null);
    }
    $reject(itemId, item) {
      const {
        siteId,
        oldTier
      } = item;
      return Promise.all([
        this.$approve(itemId),
        this.$firedux.ref('sites').child(siteId).child('metadata/tier').set(oldTier)
      ]);
    }
  }
  angular
    .module('approval.tierUpdates', [])
    .component('approvalTierUpdates', {
      controller: Controller,
      templateUrl: 'root/approval/_components/tierUpdates/tierUpdates-approval.comp.html',
      bindings: {}
    });
}());
